import { render, staticRenderFns } from "./AdminBlog.vue?vue&type=template&id=8091fd12&"
import script from "./AdminBlog.vue?vue&type=script&lang=js&"
export * from "./AdminBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports